import React, {useState, useEffect} from 'react';
import {
  useSelector,
  useDispatch
} from 'react-redux';
import {
  Icon,
  Image
} from '../../utils/general';

import './back.scss';

export const Background = () => {
  const wall = useSelector(state => state.wallpaper);
  const dispatch = useDispatch();

  return (
    <div className="background" style={{
      backgroundImage: `url(/img/wallpaper/${wall.src})`
    }}>
    </div>
  );
}

export const BootScreen = (props) => {
  const dispatch = useDispatch();
  const wall = useSelector(state => state.wallpaper);
  const [blackout, setBlackOut] = useState(false);

  useEffect(()=>{
    if(props.dir<0){
      setTimeout(()=>{
        console.log("blackout");
        setBlackOut(true);
      },4000)
    }
  },[props.dir])

  useEffect(()=>{
    if(props.dir<0){
      if(blackout){
        if(wall.act=="restart"){
          setTimeout(()=>{
            setBlackOut(false)
            setTimeout(()=>{
              dispatch({type: "WALLBOOTED"})
            },4000)
          },2000)
        }
      }
    }
  }, [blackout])

  return (
    <div className="bootscreen">
      <div className={blackout?"hidden":""}>
        <Image src="asset/bootlogo" w={180}/>
        <div className="mt-48" id="loader">
          <div id="dotcont">
            <div className='circle'></div>
            <div className='circle'></div>
            <div className='circle'></div>
            <div className='circle'></div>
            <div className='circle'></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const LockScreen = (props) => {
  const wall = useSelector(state => state.wallpaper);
  const [lock, setLock] = useState(false);
  const [unlocked, setUnLock] = useState(false);
  const [password, setPass] = useState("");
  const [passType, setType] = useState(1);
  const [forgot, setForget] = useState(false);
  const dispatch = useDispatch();

  const action = (e)=>{
    var act = e.target.dataset.action,
        payload = e.target.dataset.payload;

    if(act=="splash") setLock(true);
    else if (act=="inpass"){
      var val = e.target.value
      if(!passType){
        val = val.substring(0,4)
        val = !Number(val)?"":val
      }

      setPass(val)
    }else if (act=="forgot") setForget(true);
    else if (act=="pinlock") setType(0);
    else if (act=="passkey") setType(1);

    if (act=="pinlock" || act=="passkey") setPass("");
  }

  const proceed = ()=>{
    setUnLock(true);
    setTimeout(()=>{
      dispatch({type: "WALLUNLOCK"})
    },1000)
  }

  const action2 = (e)=>{
    if(e.key=="Enter") proceed()
  }

  return (
    <div className={"lockscreen " +
      (props.dir==-1?"slowfadein":"")} data-unlock={unlocked} style={{
        backgroundImage: `url(${`/img/wallpaper/lock.jpg`})`
      }} onClick={action} data-action="splash" data-blur={lock}>
      <div className="splashScreen mt-40" data-faded={lock}>
        <div className="text-6xl font-semibold text-gray-100">
          {new Date().toLocaleTimeString("en-US",{
            hour: 'numeric', minute: 'numeric', hour12: true
          })}
        </div>
        <div className="text-lg font-medium text-gray-200">
          {new Date().toLocaleDateString("en-US",{
            weekday: "long", month:"long",day: "numeric"
          })}
        </div>
      </div>
      <div className="fadeinScreen" data-faded={!lock} data-unlock={unlocked}>
        {/* <Image className="rounded-full overflow-hidden"
          src="/img/asset/prof.jpg" w={160} ext/> */}
          <svg height="100" aria-hidden="true" viewBox="0 0 16 16" version="1.1" width="100" data-view-component="true" class="octicon octicon-mark-github v-align-middle">
    <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
</svg>
        <div className="mt-2 text-xl font-medium text-gray-200">Admin</div>
        <div className="flex items-center mt-6">
          <input type={passType?"text":"password"} value={password} onChange={action}
            data-action="inpass" onKeyDown={action2} placeholder={passType?"Password":"PIN"}/>
          <Icon className="-ml-6 handcr" fafa="faArrowRight" width={14}
            color="rgba(170, 170, 170, 0.6)" onClick={proceed}/>
        </div>
        <div className="text-xs text-gray-400 mt-4 handcr">
          随便什么密码都能进
        </div>
      </div>
      <div className="bottomInfo flex">
        <Icon className="mx-2" src="wifi" ui width={16} invert/>
        <Icon className="mx-2" src="battery" ui width={16} invert/>
      </div>
    </div>
  );
}
